import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import { addonCoupon, addonDetail, addonFinalSubmit, addonSubmit, CreateOrder, getCountryStateCityData, getCountryStateCityList, getcoupons, getOrder, getSubscriptionDetail, getSubscriptionList, preSubmitPackage, submitPackage } from "../../restApi/api";
import { decrypt } from "../../utils/crypto";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import Modal from "react-bootstrap/Modal";
import Toggle from "react-toggle"
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import { Package_detail_Api } from "../../gql/queries";
import { useQuery } from "@apollo/client";
import SomethingWentWrong from "../common/NoDataFound/SomethingWentWrong";
import ConnectionError from "../common/NoDataFound/ConnectionError";
// import Razorpay from 'razorpay';

const INITIAL_STATE = {
    colonyArea: '',
    city: '',
    country: '',
    flateNumber: '',
    landmark: '',
    pincode: '',
    state: '',
    shippingcolonyArea: '',
    shippingcity: '',
    shippingcountry: '',
    shippingflateNumber: '',
    shippinglandmark: '',
    shippingpincode: '',
    shippingstate: '',
};
export default function Addons() {
    function loadScript(src) {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false);
            };
            document.body.appendChild(script);
        });
    }

    let { id } = useParams()
    let location = useLocation();
    const navigate = useNavigate();
    const [orderShow, setOrder] = useState(false);
    const orderInfo = () => setOrder(true);
    const orderHide = () => setOrder(false);
    const [country, setCountry] = useState(null);
    const [state, setState] = useState(null);
    const [city, setCity] = useState(null);
    const [shipcountryId, setshipcountryId] = useState(null);
    const [shipstateId, setshipStateId] = useState(null);
    const [shipcityId, setshipCityId] = useState(null);
    const [shipstate, setshipState] = useState(null);
    const [shipcountry, setshipCountry] = useState(null);
    const [shipcity, setshipCity] = useState(null);
    const [coupon, setCoupon] = useState('');
    const [course, setCourse] = useState(JSON.parse(decrypt(localStorage.getItem('profileDetails'))));
    const [getProfileDetails, profileDetails] = useState(INITIAL_STATE);
    const [countryId, setcountryId] = useState(null);
    const [stateId, setStateId] = useState(null);
    const [cityId, setCityId] = useState(null);
    const [subscription, setSubscription] = useState([]);
    const [validity, setValidity] = useState({});
    const [packages, setPackage] = useState(true);
    let [notes, setNotes] = useState(false);
    let [vibes, setVibes] = useState(false);
    const [TotalAmount, setAmount] = useState(0)
    const [index, setIndex] = useState(0);
    const [Price, setPrice] = useState(0)
    const [vibecouponPrice, setvibePrice] = useState(0)
    const [notePriceshow, setNotePrice] = useState(0)
    const [pendrivePriceshow, setPendrivePrice] = useState(0)
    const [redeemshow, setredeem] = useState(0)
    let [paymentDetail, setpaymentDetail] = useState({});
    const [packagekey, setpackagekey] = useState(1);
    const [Checkedbox, setCheckbox] = useState(false);
    let [discountPercentage, setdiscountPercentage] = useState(0)
    let [vibediscountPercentage, setvibediscountPercentage] = useState(0)
    let [loader, setloader] = useState(false)
    let [count, setCount] = useState(0);
    let Shippingcountry = ''
    let Billingcity = ''
    let Billingstate = ''
    let BillingCountry = ''
    let Shippingstate = ''
    let Shippingcity = ''
    let totalprice = 0
    let NotesPrice = 0
    let PendrivePrice = 0
    let couponPrice = 0
    // let discountPercentage=0
    let isShip = false;
    let isBilling = false;


    const showToast = (message) => {
        toast.success(message);
    };

    const showToastError = (message) => {
        toast.error(message);
    };
    const makeApiCall = () => {
        const data = {
            "orderId": paymentDetail?.notes?.orderId
        }
        getOrder(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (data.success == true) {
                    if (data.data.transactionStatus == 'COMPLETED') {
                        navigate(`/success/${query1?.data?.listPackagesForApp[0]?.title}/${'add-on'}`)
                    }
                    else if (data.data.transactionStatus == 'PENDING' || data.data.transactionStatus == 'INITIATED') {
                        var intervalId
                        if (count < 1) {
                            makeApiCall()
                            count = count + 1
                            setCount(count + 1)
                        } else {
                            intervalId = setInterval(makeApiCall, 1000);
                            clearInterval(intervalId); // Stop the interval
                            navigate('/pending')
                        }
                    }
                    else {
                        navigate('/error')
                    }
                }

            }).catch((error) => {
                showToastError("Something went wrong please try agian")
            })
    }
    const note = (e) => {
        notes = e.target.checked
        setNotes(e.target.checked)
        calculatePrice(validity)

    }
    const vibe = (e) => {
        vibes = e.target.checked
        setVibes(e.target.checked)
        calculatePrice(validity)

    }
    const handleInputChange = function (fieldValue, fieldName) {
        profileDetails({ ...getProfileDetails, [fieldName]: fieldValue })
    }
    const getCountry = async () => {
        const data = {
            "country": "",
            "state": "",
            "city": "",
            "courses": course?.preparingFor
        }
        await getCountryStateCityData(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                setCountry(data)
                setshipCountry(data)
                setState('')
                setCity('')
                setshipCity('')
                setshipState('')
            })
    }

    const selectCountry = async (slctCountry) => {
        profileDetails({
            ...getProfileDetails,
            country: slctCountry ? slctCountry.target.value : countryId
        })
        const data = {
            "country": slctCountry ? slctCountry.target.value : countryId,
            "state": "",
            "city": "",
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (data.data.result?.states) {
                    setState(data)
                    setCity(null)
                    return
                }
                setState(null)
                setCity(null)
                return
                // setState(data)
                // setStateId(data.data.result.states[0]._id)
            })
    }

    const selectState = async (slctState) => {
        profileDetails({
            ...getProfileDetails,
            state: slctState ? slctState.target.value : stateId
        })
        const data = {
            "country": "",
            "state": slctState ? slctState.target.value : stateId,
            "city": "",
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                // selectCity()
                if (data.data.result?.city) {
                    setCity(data)
                    return
                }
                setCity(null)
                return
                // setCity(data)
                // setCityId(data.data.result.city[0]._id)
            })
    }
    const selectCity = async (slctCity) => {
        profileDetails({
            ...getProfileDetails,
            city: slctCity ? slctCity.target.value : cityId
        })
        const data = {
            "country": "",
            "state": "",
            "city": slctCity ? slctCity.target.value : cityId,
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {

            })
    }
    const couponEnter = (e) => {
        setCoupon((e.target.value).trimStart())
    }
    const selectShipCountry = async (slctCountry) => {
        profileDetails({
            ...getProfileDetails,
            shippingcountry: slctCountry ? slctCountry.target.value : shipcountryId
        })
        const data = {
            "country": slctCountry ? slctCountry.target.value : shipcountryId,
            "state": "",
            "city": "",
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (data.data.result?.states) {
                    setshipState(data)
                    setshipCity(null)
                    return
                }
                setshipState(null)
                setshipCity(null)
                return
                // setshipState(data)
                //     setshipStateId(data.data.result.states[0]._id)
            })
    }

    const selectShipState = async (slctState) => {
        profileDetails({
            ...getProfileDetails,
            shippingstate: slctState ? slctState.target.value : shipstateId,
        })
        const data = {
            "country": "",
            "state": slctState ? slctState.target.value : shipstateId,
            "city": "",
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                if (data.data.result?.city) {
                    setshipCity(data)
                    return
                }
                setshipCity(null)
                return
                // setshipCity(data)
                // setshipCityId(data.data.result.city[0]._id)
            })
    }
    const selectShipCity = async (slctCity) => {
        profileDetails({
            ...getProfileDetails,
            shippingcity: slctCity ? slctCity.target.value : shipcityId
        })
        const data = {
            "country": "",
            "state": "",
            "city": slctCity ? slctCity.target.value : shipcityId,
            "courses": course?.preparingFor
        }
        await getCountryStateCityList(data)
            .then(response => {
                return response.json()
            })
            .then(data => {

            })
    }
    const RemoveCoupon = () => {
        if (coupon == '') {
            setpackagekey(2)
            setCoupon('')
            calculatePrice(validity)
        }
        setCoupon('')
        setpackagekey(1)
        discountPercentage = 0
        setdiscountPercentage(0)
        calculatePrice(validity)
        showToastError('Coupon Removed Successful')
    }

    const addCoupon = async () => {
        setpackagekey(1)
        if (coupon == '' || coupon == undefined || coupon == null) {
            discountPercentage = 0
            setdiscountPercentage(0)
            calculatePrice(validity)
            setpackagekey(1)
            showToastError('Please Apply Any Coupon')
            return
            //  this.notificationService.show('Please Apply Any Coupon')
        }
        const data = {
            couponName: coupon,
            notesPackageId: validity?.notes?.notesPackageId,
            penDrivePackageId: validity?.penDrive?.penDrivePackageId,
        }
        await addonCoupon(data)
            .then(response => {
                return response.json()
            })
            .then(data => {
                let req = JSON.parse(decrypt(data))
                if (req.data.code == 1) {
                    setloader(false)
                    discountPercentage = req.data.result.discount.notesDiscountPrice
                    setdiscountPercentage(req.data.result.discount.notesDiscountPrice)
                    vibediscountPercentage = req.data.result.discount.penDriveDiscountPrice
                    setvibediscountPercentage(req.data.result.discount.penDriveDiscountPrice)
                    calculatePrice(validity)
                    showToast(req.data.message)
                    setpackagekey(2)
                }
                else {
                    showToastError(req.data.message)
                }
            }).catch((error) => {
                setloader(false)
            })
    }

    const calculatePrice = () => {
        if (validity?.withNotes && notes == true) {
            if (validity?.notes?.isCouponApply == true) {
                if (validity?.notes?.afterBuyNotesPrice != 0) {
                    NotesPrice = validity?.notes?.afterBuyNotesDiscount !== 0 ? validity?.notes?.afterBuyNotesDiscount : validity.notes?.afterBuyNotesPrice
                    setNotePrice(NotesPrice)
                }
                // else if(validity?.notes?.notesPrice!=0){
                //   NotesPrice=validity?.notes?.notesDiscount?validity?.notes?.notesDiscount:validity?.notes?.notesPrice
                //   setNotePrice(NotesPrice)
                // }
                if (discountPercentage != 0) {
                    couponPrice = (NotesPrice * discountPercentage) / 100
                    NotesPrice = NotesPrice - couponPrice
                    setPrice(couponPrice)
                    setNotePrice(NotesPrice)
                }
            }
            else {
                if (validity?.notes.afterBuyNotesPrice != 0) {
                    NotesPrice = validity?.notes?.afterBuyNotesDiscount !== 0 ? validity?.notes?.afterBuyNotesDiscount : validity.notes?.afterBuyNotesPrice
                    setNotePrice(NotesPrice)
                }
                // else if(validity?.notes?.notesPrice!=0){
                //   NotesPrice=validity?.notes?.notesDiscount?validity?.notes?.notesDiscount:validity?.notes?.notesPrice
                //   setNotePrice(NotesPrice)
                // }
                setPrice(0)
                NotesPrice = NotesPrice
                setNotePrice(NotesPrice)
            }
        }
        else {
            setPrice(0)
            setNotePrice(0)
        }
        if (validity?.withPenDrive && vibes == true) {
            if (validity?.penDrive?.isCouponApply == true) {
                if (validity?.penDrive?.afterBuyPendrivePrice != 0) {
                    PendrivePrice = validity?.penDrive?.afterBuyPendriveDiscount !== 0 ? validity?.penDrive?.afterBuyPendriveDiscount : validity?.penDrive?.afterBuyPendrivePrice
                    setPendrivePrice(PendrivePrice)
                }
                // else if(validity?.notes?.notesPrice!=0){
                //   PendrivePrice=validity?.penDrive?.penDriveDiscount?validity?.penDrive?.penDriveDiscount:validity?.penDrive?.penDrivePrice
                //   setPendrivePrice(PendrivePrice)
                // }

                if (vibediscountPercentage != 0) {
                    vibecouponPrice = (PendrivePrice * vibediscountPercentage) / 100
                    PendrivePrice = PendrivePrice - vibecouponPrice
                    setPendrivePrice(PendrivePrice)
                    setvibePrice(vibecouponPrice)
                }
            }
            else {
                if (validity?.penDrive?.afterBuyPendrivePrice != 0) {
                    PendrivePrice = validity?.penDrive?.afterBuyPendriveDiscount !== 0 ? validity?.penDrive?.afterBuyPendriveDiscount : validity?.penDrive?.afterBuyPendrivePrice
                    setPendrivePrice(PendrivePrice)
                }
                // else if(validity?.notes?.notesPrice!=0){
                //   PendrivePrice=validity?.penDrive?.penDriveDiscount ? validity?.penDrive?.penDriveDiscount:validity?.penDrive?.penDrivePrice
                //   setPendrivePrice(PendrivePrice)
                // }

                PendrivePrice = PendrivePrice
                setPendrivePrice(PendrivePrice)
            }
        }
        else {
            setPendrivePrice(PendrivePrice)
        }
        totalprice = (PendrivePrice + NotesPrice)
        setAmount((totalprice).toFixed(2))
    }
    useEffect(() => {
        countryId && selectCountry()
    }, [countryId])

    useEffect(() => {
        stateId && selectState()
    }, [stateId])

    useEffect(() => {
        cityId && selectCity()
    }, [cityId])
    useEffect(() => {
        shipcountryId && selectShipCountry()
    }, [shipcountryId])
    useEffect(() => {
        shipstateId && selectShipState()
    }, [shipstateId])

    useEffect(() => {
        shipcityId && selectShipCity()
    }, [shipcityId])

    useEffect(() => {
        getCountry()
    }, [])
    const query1 = useQuery(Package_detail_Api, {
        variables: {
            "packageId": id,
            "packageType": 'SUBSCRIPTION'
        },
        fetchPolicy: 'network-only'
    });
    useEffect(() => {
        query1.data?.listPackagesForApp[0]?.validity?.map((obj, i) => {
            if ((obj._id) === (query1.data?.listPackagesForApp[0]?.packagePurchased?.validityId)) {
                setValidity(query1.data?.listPackagesForApp[0]?.validity[i])
            }
        })
        calculatePrice(validity)
    }, [query1?.data])
    if (query1.loading) return (<><Loader /></>)
    if (query1.error) {
        if (query1.error?.graphQLErrors?.some((e) => e.extensions?.code === 'UNAUTHENTICATED')) {
            authorizationCheck(navigate)
        }
        else if (query1.error.graphQLErrors.some((e) => e.extensions?.code === 'INTERNAL_SERVER_ERROR')) {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <SomethingWentWrong pathName={location.pathname} />
                    </div>
                </div>
            </>)
        }
        else {
            return (<>
                <div className="main_wrapper">
                    <div className="col-lg-12">
                        <ConnectionError pathName={location.pathname} />
                    </div>
                </div>
            </>)
        }
        console.log(query1.error)
    }

    const onSubmit = async (e) =>   // to submit  the form
    {
        e.preventDefault();
        if (!course?.collegeName) {
            showToastError('Please update your college details from the profile section')
            return
        }
        if (getProfileDetails?.country == '' || getProfileDetails?.state == '' || getProfileDetails?.city == '' || getProfileDetails?.colonyArea == '' || getProfileDetails?.pincode == '' || getProfileDetails?.flateNumber == '') {
            isBilling = true;
        } else {
            isBilling = true;
        }
        if (getProfileDetails?.shippingcountry == '' || getProfileDetails?.shippingstate == '' || getProfileDetails?.shippingcity == '' || getProfileDetails?.shippingcolonyArea == '' || getProfileDetails?.shippingpincode == '' || getProfileDetails?.shippingflateNumber == '') {
            isShip = false;
        } else {
            isShip = true;
            // this.notificationService.show('Please fill all mandatory fields in Shipping Address')
        }
        if (isBilling == true) {
            if ((notes == true || vibes == true) && isShip == true) {
                if (getProfileDetails?.country != '') {
                    country?.data?.result?.countries?.map((obj) => {
                        if (obj._id == getProfileDetails?.country) {
                            BillingCountry = (obj.title)
                        }
                    })
                }
                if (getProfileDetails?.state != '') {
                    state?.data?.result?.states?.map((obj) => {
                        if (obj._id == getProfileDetails?.state) {
                            Billingstate = (obj.title)
                        }
                    })
                }
                if (getProfileDetails?.city != '') {
                    city?.data?.result?.city?.map((obj) => {
                        if (obj._id == getProfileDetails?.city) {
                            Billingcity = (obj.title)
                        }
                    })
                }
                if (getProfileDetails?.shippingcountry != '') {
                    shipcountry?.data?.result?.countries?.map((obj) => {
                        if (obj._id == getProfileDetails?.shippingcountry) {
                            Shippingcountry = (obj.title)
                        }
                    })

                }
                if (getProfileDetails?.shippingstate != '') {
                    shipstate?.data?.result?.states?.map((obj) => {
                        if (obj._id == getProfileDetails?.shippingstate) {
                            Shippingstate = (obj.title)
                        }
                    })
                }
                if (getProfileDetails?.shippingcity != '') {
                    shipcity?.data?.result?.city?.map((obj) => {
                        if (obj._id == getProfileDetails?.shippingcity) {
                            Shippingcity = (obj.title)
                        }
                    })
                }
                const data = {
                    "couponName": coupon,
                    "currency": "INR",
                    "packageId": id,
                    "packageType": 1,
                    "purchaseType": "ADDONS",
                    "boughtWithNotes": notes,
                    "boughtWithVibe": vibes,
                    "validityId": validity?._id,
                    "billingAddress": {
                        "colonyArea": getProfileDetails?.colonyArea,
                        "city": Billingcity != undefined ? Billingcity : '',
                        "country": BillingCountry != undefined ? BillingCountry : '',
                        "flatNumber": getProfileDetails?.flateNumber,
                        "landmark": getProfileDetails?.landmark,
                        "pincode": getProfileDetails?.pincode,
                        "state": Billingstate != undefined ? Billingstate : '',
                        "fullAddress": getProfileDetails?.flateNumber + "," + getProfileDetails?.colonyArea + "," + getProfileDetails?.landmark + "," + Billingcity + "," + Billingstate + "," + getProfileDetails?.pincode,
                    },
                    "shippingAddress": {
                        "colonyArea": getProfileDetails?.shippingcolonyArea,
                        "city": Shippingcity != undefined ? Shippingcity : '',
                        "country": Shippingcountry != undefined ? Shippingcountry : '',
                        "flatNumber": getProfileDetails?.shippingflateNumber,
                        "landmark": getProfileDetails?.shippinglandmark,
                        "pincode": getProfileDetails?.shippingpincode,
                        "state": Shippingstate != undefined ? Shippingstate : '',
                        "fullAddress": getProfileDetails?.shippingflateNumber + "," + getProfileDetails?.shippingcolonyArea + "," + getProfileDetails?.shippinglandmark + "," + Shippingcity + "," + Shippingstate + "," + getProfileDetails?.shippingpincode,
                    },
                }
                setloader(true)
                await CreateOrder(data)
                    .then((response) => {
                        return response.json()
                    })
                    .then((data) => {
                        if (data.success == true) {
                            setloader(false)
                            paymentDetail = data.data
                            setpaymentDetail(data.data)
                            razorpayDetails(e)
                        }
                        else if (data.success == false) {
                            showToastError(data.message)
                        }
                    }).catch((err) => {
                        setloader(false)
                        showToastError("Something went wrong please try again")
                    })
            } else {
                if ((notes == true || vibes == true) && (validity?.withNotes == true || validity?.withPenDrive == true)) {
                    isShip = false;
                    showToastError('Please fill all details in shipping address')
                }
                else {
                    if (getProfileDetails?.country != '') {
                        country?.data?.result?.countries.map((obj) => {
                            if (obj._id == getProfileDetails?.country) {
                                BillingCountry = (obj.title)
                            }
                        })
                    }
                    if (getProfileDetails?.state != '') {
                        state?.data?.result?.states?.map((obj) => {
                            if (obj._id == getProfileDetails?.state) {
                                Billingstate = (obj.title)
                            }
                        })
                    }
                    if (getProfileDetails?.city != '') {
                        city?.data?.result?.city?.map((obj) => {
                            if (obj._id == getProfileDetails?.city) {
                                Billingcity = (obj.title)
                            }
                        })
                    }
                    if (getProfileDetails?.shippingcountry != '') {
                        shipcountry?.data?.result?.countries?.map((obj) => {
                            if (obj._id == getProfileDetails?.shippingcountry) {
                                Shippingcountry = (obj.title)
                            }
                        })

                    }
                    if (getProfileDetails?.shippingstate != '') {
                        shipstate?.data?.result?.states?.map((obj) => {
                            if (obj._id == getProfileDetails?.shippingstate) {
                                Shippingstate = (obj.title)
                            }
                        })
                    }
                    if (getProfileDetails?.shippingcity != '') {
                        shipcity?.data?.result?.city?.map((obj) => {
                            if (obj._id == getProfileDetails?.shippingcity) {
                                Shippingcity = (obj.title)
                            }
                        })
                    }
                    const data = {
                        "couponName": coupon,
                        "currency": "INR",
                        "packageId": id,
                        "packageType": 1,
                        "purchaseType": "ADDONS",
                        "boughtWithNotes": notes,
                        "boughtWithVibe": vibes,
                        "validityId": validity?._id,
                        "billingAddress": {
                            "colonyArea": getProfileDetails?.colonyArea,
                            "city": Billingcity != undefined ? Billingcity : '',
                            "country": BillingCountry != undefined ? BillingCountry : '',
                            "flatNumber": getProfileDetails?.flateNumber,
                            "landmark": getProfileDetails?.landmark,
                            "pincode": getProfileDetails?.pincode,
                            "state": Billingstate != undefined ? Billingstate : '',
                            "fullAddress": getProfileDetails?.flateNumber + "," + getProfileDetails?.colonyArea + "," + getProfileDetails?.landmark + "," + Billingcity + "," + Billingstate + "," + getProfileDetails?.pincode,
                        },
                        "shippingAddress": {
                            "colonyArea": getProfileDetails?.shippingcolonyArea,
                            "city": Shippingcity != undefined ? Shippingcity : '',
                            "country": Shippingcountry != undefined ? Shippingcountry : '',
                            "flatNumber": getProfileDetails?.shippingflateNumber,
                            "landmark": getProfileDetails?.shippinglandmark,
                            "pincode": getProfileDetails?.shippingpincode,
                            "state": Shippingstate != undefined ? Shippingstate : '',
                            "fullAddress": getProfileDetails?.shippingflateNumber + "," + getProfileDetails?.shippingcolonyArea + "," + getProfileDetails?.shippinglandmark + "," + Shippingcity + "," + Shippingstate + "," + getProfileDetails?.shippingpincode,
                        },
                    }
                    setloader(true)
                    await CreateOrder(data)
                        .then((response) => {
                            return response.json()
                        })
                        .then((data) => {
                            if (data.success == true) {
                                setloader(false)
                                paymentDetail = data.data
                                setpaymentDetail(data.data)
                                razorpayDetails(e)
                            }
                            else if (data.success == false) {
                                showToastError(data.message)
                            }
                        }).catch((err) => {
                            showToastError("Something went wrong please try agian")
                            setloader(false)
                        })
                }
            }
        } else {
            showToastError('Please fill all mandatory fields in billing Address')
            setloader(false)
        }
    }
    const razorpayDetails = async (e) => {
        e.preventDefault()
        var notesAddon
        if (validity?.withNotes) {
            notesAddon = {
                "notesAddOn": validity?.withNotes != false ? validity?.notes?.title + ',' + NotesPrice : '',
            }
        }
        var pendriveAddon
        if (validity?.withPenDrive) {
            pendriveAddon = {
                "pendriveAddOn": validity?.withPenDrive != false ? validity?.penDrive.title + ',' + PendrivePrice : '',
            }
        }
        var options = {
            "key": process.env.REACT_APP_Razorpay_Key, // Enter the Key ID generated from the Dashboard
            "amount": TotalAmount * 100, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            "currency": "INR",
            "name": "eGurukul",
            "description": course?.name,
            "image": "https://rzp-mobile.s3.amazonaws.com/images/rzp.png",
            "order_id": paymentDetail?.id, //This is a sample Order ID. Pass the `id` obtained in the response of Step 1
            "capture": "0",
            "method": "all",
            "handler": (response) => {
                setloader(false)
                makeApiCall()
                // const data = {
                //     "orderId": paymentDetail?.notes?.orderId
                // }
                // getOrder(data)
                //     .then((response) => {
                //         return response.json()
                //     })
                //     .then(data => {
                //         if (data.success == true) {
                //             setloader(false)
                //             if (data.data.transactionStatus == 'COMPLETED') {
                //                 navigate('/success')
                //             }
                //             else if(data.data.transactionStatus == 'PENDING' || data.data.transactionStatus == 'INITIATED') {
                //                 navigate('/pending')
                //             }
                //             else{
                //                 navigate('/error')

                //             }
                //         }

                //     }).catch((error) => {
                //         setloader(false)
                //         showToastError("Something went wrong please try agian")
                //     })
                //    submitpackage(response.razorpay_payment_id,true)
            },
            "prefill": {
                "name": course?.name,
                "email": course?.email,
                "contact": course?.mobileNo,
                "method": "All",
                "_[flow]": "intent",
                "upi_app_package_name": "com.phonepe.app",
                "prefill": "preFill"
            },
            // "notes": {
            //     "appOrderId": "WEB_" + paymentDetail?.notes?.orderId,
            //     "mobileNo": course.mobileNo,
            //     "invoiceId": paymentDetail?.notes?.invoiceNumber,
            //     ...notesAddon,
            //     ...pendriveAddon,
            //     "packageDetails": "AddOns",
            //     "month": validity?.months,
            //     "billingAddress": getProfileDetails?.flateNumber + "," + getProfileDetails?.colonyArea + "," + getProfileDetails?.landmark + "," + Billingcity + "," + Billingstate + "," + getProfileDetails?.pincode,
            //     "couponName": coupon != null ? coupon : '',
            //     "college": course.country + "," + course.collegeState + ',' + course.collegeCity + ',' + course.collegeName,
            //     "shippingAddress": getProfileDetails?.shippingflateNumber + "," + getProfileDetails?.shippingcolonyArea + "," + getProfileDetails?.shippinglandmark + "," + Shippingcity + "," + Shippingstate + "," + getProfileDetails?.shippingpincode,
            // },
            "theme": {
                "color": "#3AC3FF",
                "hide_topbar": "true",
                "theme": "theme"
            }
        }
        const res = await loadScript(
            "https://checkout.razorpay.com/v1/checkout.js"
        );
        let razorpay = new window.Razorpay(options);
        razorpay.open();
        razorpay.on('payment.failed', (response) => {
            makeApiCall()
            // console.log( response.error.metadata.payment_id);
            // submitpackage(response.error.metadata.payment_id,false)
        });
    }
    const checkBoxMark = (e) => {
        if (e.target.checked) {
            isShip = true;
            isBilling = true;
            setshipState(state)
            setshipCity(city)
            profileDetails({
                ...getProfileDetails,
                shippinglandmark: getProfileDetails?.landmark,
                shippingpincode: getProfileDetails?.pincode,
                shippingflateNumber: getProfileDetails?.flateNumber,
                shippingcolonyArea: getProfileDetails?.colonyArea,
                shippingcity: getProfileDetails?.city,
                shippingcountry: getProfileDetails?.country,
                shippingstate: getProfileDetails?.state
            })
            setCheckbox(true)
        }
        else {
            isShip = false;
            isBilling = true;
            setshipState(null)
            setshipCity(null)
            profileDetails({
                ...getProfileDetails,
                shippinglandmark: '',
                shippingpincode: '',
                shippingflateNumber: '',
                shippingcolonyArea: '',
                shippingcity: '',
                shippingcountry: '',
                shippingstate: '',
            })
            setCheckbox(false)
        }
    }
    return (
        <>
            <div className="main_wrapper">
                <div className="breadcrumbs">
                    <ul className="breadcrumb">
                        <li className="breadcrumb-item"><a >Home</a></li>
                        <li className="breadcrumb-item active"><a >Subscription</a></li>
                    </ul>
                </div>
                <section className="videoLayer_wrapper subscription_plans_wrapper section_side_padding">
                    <ToastContainer autoClose={500} limit={1} />
                    <div className='row'>
                        <div className="col-lg-8 col-md-7 col-sm-12">
                            <div className="recommended_video_wrapper">
                                <div className="choose_plans_wrapper d-flex align-items-center">
                                    <figure className="arrow">
                                        <Link to={'/package'}>
                                            <img src={Icons.BackArrow} alt="" className="img-fluid" />
                                        </Link>
                                    </figure>
                                    <div className="subscription_ttl">
                                        <h5>Add-on Purchase</h5>
                                    </div>
                                </div>
                            </div>
                            {
                                (validity?.withNotes || validity?.withPenDrive) &&
                                <div className="recommended_video_wrapper">
                                    <div className="plans_details_wrapper">
                                        <div className="plans_main_ttl">
                                            <h5>Add-Ons</h5>
                                        </div>
                                        <div className="addon_wrapper">
                                            <div className="row">
                                                {
                                                    (validity?.withNotes && query1.data?.listPackagesForApp[0]?.packagePurchased?.boughtWithNotes === false) &&
                                                    <div className="col-lg-6 col-md-6 col-sm-12" >
                                                        <label For="addonSelected">
                                                            <input type="checkbox" id="addonSelected" name="addonCheckbox" hidden onClick={(e) => note(e)} />
                                                            <div className={`plans_wrapper ${notes && notes == true ? 'selected' : ''}`}>
                                                                <div className="plans_header d-flex align-items-center">
                                                                    <div className="plans_name">
                                                                        <h6>Notes</h6>
                                                                        <p>Hard Copy</p>
                                                                    </div>
                                                                    <div className="plan_price">
                                                                        <h6>₹{validity?.notes?.afterBuyNotesDiscount !== 0 ? validity?.notes?.afterBuyNotesDiscount : validity?.notes?.afterBuyNotesPrice}</h6>
                                                                        {
                                                                            validity?.notes?.afterBuyNotesDiscount !== 0 &&
                                                                            <p><del>₹ {validity?.notes.afterBuyNotesPrice}</del></p>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="plans_body">
                                                                    <div dangerouslySetInnerHTML={{ __html: `${validity?.notes?.description != "undefined" ? validity?.notes?.description : ""}` }}></div>
                                                                    {/* <ul type="none">
                                                                <li>Only Notes  are available in this package.</li>
                                                                <li>Video timestamps are included in subtopics for fast browsing.</li>
                                                                <li>Includes Previous Year Recall Questions.</li>
                                                                <li>Includes beautiful digital illustrations of diagrams.</li>
                                                                <li>Attractive digital handwritten fonts that make you read the note.</li>
                                                                <li>Key points are highlighted for rapid revision.</li>
                                                                <li>Notes contain 2x High-Definition images.</li>
                                                            </ul> */}
                                                                </div>
                                                            </div>
                                                        </label>
                                                    </div>
                                                }
                                                {
                                                    (validity?.withPenDrive && query1.data?.listPackagesForApp[0]?.packagePurchased?.boughtWithVibe == false) &&
                                                    <div className="col-lg-6 col-md-6 col-sm-12" >
                                                        <label For="vibeSelected">
                                                            <input type="checkbox" id="vibeSelected" name="addonCheckbox" onClick={(e) => vibe(e)} hidden />
                                                            <div className={`plans_wrapper ${vibes && vibes === true ? 'selected' : ''}`}>
                                                                <div className="plans_header d-flex align-items-center">
                                                                    <div className="plans_name">
                                                                        <h6>Vibe</h6>
                                                                        <p>View Type 1x</p>
                                                                    </div>
                                                                    <div className="plan_price">
                                                                        <h6>₹{validity?.penDrive?.afterBuyPendriveDiscount !== 0 ? validity?.penDrive?.afterBuyPendriveDiscount : validity?.penDrive?.afterBuyPendrivePrice}</h6>
                                                                        {
                                                                            validity?.penDrive?.afterBuyPendriveDiscount !== 0 &&
                                                                            <p><del>₹ {validity?.penDrive?.afterBuyPendrivePrice}</del></p>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div className="plans_body">
                                                                    <div dangerouslySetInnerHTML={{ __html: `${validity?.penDrive?.description != "undefined" ? validity?.penDrive?.description : ""}` }} ></div>
                                                                    {/* <ul type="none">
                                                    <li>Only Notes  are available in this package.</li>
                                                    <li>Video timestamps are included in subtopics for fast browsing.</li>
                                                    <li>Includes Previous Year Recall Questions.</li>
                                                    <li>Includes beautiful digital illustrations of diagrams.</li>
                                                    <li>Attractive digital handwritten fonts that make you read the note.</li>
                                                    <li>Key points are highlighted for rapid revision.</li>
                                                    <li>Notes contain 2x High-Definition images.</li>
                                                </ul> */}
                                                                </div>
                                                            </div>
                                                        </label>
                                                    </div>
                                                }
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            }
                            {/* <div className="recommended_video_wrapper">
                                <div className="plans_details_wrapper">
                                    <div className="plans_main_ttl">
                                        <h5>Enter Coupon Code</h5>
                                    </div>
                                    <div className="coupon_code">
                                        <div className="coupon_input d-flex align-item-center">
                                            <div className="code">
                                                {
                                                    packagekey == 1 &&
                                                    <input type="text" className="form-control" placeholder="Write Here" value={coupon} onChange={(e) => couponEnter(e)} />
                                                }
                                                {
                                                    packagekey == 2 &&
                                                    <input type="text" className="form-control" placeholder="Write Here" value={coupon} disabled={true} onChange={(e) => couponEnter(e)} />
                                                }
                                            </div>
                                            <div className="apply_btn">
                                                {packagekey == 1 &&
                                                    <button type="button" className="btn btn_apply" onClick={addCoupon}>Apply <img src={Icons.ArrowBlue} alt="" className="img-fluid" /></button>
                                                }
                                                {
                                                    packagekey == 2 &&
                                                    <button type="button" className="btn btn_apply" onClick={RemoveCoupon}>Reset <img src={Icons.ArrowBlue} alt="" className="img-fluid" /></button>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            <div className="form_submission">
                                <form onSubmit={(e) => { onSubmit(e) }}>
                                    {/* <div className="recommended_video_wrapper">
                                        <div className="plans_details_wrapper">
                                            <div className="plans_main_ttl">
                                                <h5>Billing Address</h5>
                                            </div>
                                            <div className="billing_address">
                                                <div className="row">
                                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                                        <div className="form-group">
                                                            <input type="text" className="form-control" id="" placeholder="Flat, House No., Building, Apartment*" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'flateNumber')} value={getProfileDetails?.flateNumber} />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                                        <div className="form-group">
                                                            <input type="text" className="form-control" id="" placeholder="Area, Colony, Street, Sector, Village*" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'colonyArea')} value={getProfileDetails?.colonyArea} />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                                        <div className="form-group">
                                                            <input type="text" className="form-control" id="" placeholder="Landmark" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'landmark')} value={getProfileDetails?.landmark} />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                                        <div className="form-group">
                                                            <input type="text" className="form-control" maxlength="6" id="" placeholder="Pincode*" onChange={(e) => handleInputChange(((e.target.value).trimStart()).replace(/\D/g, ''), 'pincode')} value={getProfileDetails?.pincode} />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                                        <div className="form-group">
                                                            <select name="" id="" className="form-control" onChange={(event) => selectCountry(event)}>
                                                                <option value="" selected >Select Country</option>
                                                                {
                                                                    country && country.data.result.countries.map((d, i) => (
                                                                        <option value={d._id} selected={getProfileDetails.country && getProfileDetails.country === d._id}>{d.title}</option>
                                                                    ))
                                                                }

                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                                        <div className="form-group">
                                                            <select name="" id="" className="form-control" onChange={(event) => selectState(event)}>
                                                                <option value="" selected >Select State</option>
                                                                {
                                                                    (state != null && state.data) && state.data.result.states.map((d, i) => (
                                                                        <option value={d._id} selected={getProfileDetails.state && getProfileDetails.state === d._id}>{d.title}</option>
                                                                    ))
                                                                }

                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3 col-md-6 col-sm-12">
                                                        <div className="form-group">
                                                            <select name="" id="" className="form-control" onChange={(event) => selectCity(event)}>
                                                                <option value="" selected >Select City</option>
                                                                {
                                                                    (city && city.data) && city.data.result.city.map((d, i) => (
                                                                        <option value={d._id} selected={getProfileDetails.city && getProfileDetails.city === d._id} >{d.title}</option>
                                                                    ))
                                                                }

                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="recommended_video_wrapper">
                                        <div className="plans_details_wrapper">
                                            <div className="plans_main_ttl shipping_address">
                                                <h5>Shipping Address</h5>
                                                {/* <div className="custom-control custom-checkbox">
                                                    <input type="checkbox" className="custom-control-input" id="select_ship" name="example1" checked={Checkedbox} onChange={(e) => checkBoxMark(e)} />
                                                    <label className="custom-control-label" for="select_ship">My Shipping address is same as my Billing address</label>
                                                </div> */}
                                            </div>
                                            {
                                                Checkedbox === false &&
                                                <div className="billing_address">
                                                    <div className="row">
                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <input type="text" className="form-control" id="" placeholder="Flat, House No., Building, Apartment*" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'shippingflateNumber')} value={getProfileDetails?.shippingflateNumber} />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <input type="text" className="form-control" id="" placeholder="Area, Colony, Street, Sector, Village*" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'shippingcolonyArea')} value={getProfileDetails?.shippingcolonyArea} />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <input type="text" className="form-control" id="" placeholder="Landmark" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'shippinglandmark')} value={getProfileDetails?.shippinglandmark} />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <input type="text" className="form-control" maxlength="6" id="" placeholder="Pincode*" onChange={(e) => handleInputChange(((e.target.value).trimStart()).replace(/\D/g, ''), 'shippingpincode')} value={getProfileDetails?.shippingpincode} />
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-6 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <select name="" id="" className="form-control" onChange={(event) => selectShipCountry(event)}>
                                                                    <option value="" selected >Select Country</option>
                                                                    {
                                                                        shipcountry && shipcountry.data.result.countries.map((d, i) => (
                                                                            <option value={d._id} selected={getProfileDetails.shippingcountry && getProfileDetails.shippingcountry === d._id}>{d.title}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <select name="" id="" className="form-control" onChange={(event) => selectShipState(event)}>
                                                                    <option value="" selected >Select State</option>
                                                                    {
                                                                        (shipstate != null && shipstate.data) && shipstate.data.result.states.map((d, i) => (
                                                                            <option value={d._id} selected={getProfileDetails.shippingstate && getProfileDetails.shippingstate === d._id}>{d.title}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3 col-md-6 col-sm-12">
                                                            <div className="form-group">
                                                                <select name="" id="" className="form-control" onChange={(event) => selectShipCity(event)}>
                                                                    <option value="" selected >Select City</option>
                                                                    {
                                                                        (shipcity && shipcity.data) && shipcity.data.result.city.map((d, i) => (
                                                                            <option value={d._id} selected={getProfileDetails.shippingcity && getProfileDetails.shippingcity === d._id}>{d.title}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    {
                                        (vibes == true || notes == true) &&
                                        <div className="recommended_video_wrapper ">
                                            <div className="plan_price d-flex align-items-center justify-content-between">
                                                <h3>₹ {TotalAmount} <span onClick={orderInfo}>View Details <img src={Icons.OrderDetailInfo} alt="" className="img-fluid" /></span></h3>
                                                {
                                                    <button type="submit" className="btn btn_buy">Buy Now</button>
                                                }

                                            </div>
                                        </div>
                                    }
                                </form>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12">
                            {/* <div className="videos_wrapper">
                            <div className="buy_packages d-flex align-items-center">
                            <div className="package_text">
                            <h6>Buy Package</h6>
                                    <p>Buy Package to unlock content and Start Learning</p>
                                </div>
                                <div className="package_img">
                                <img src={Images.Package} alt="" className="img-fluid"/>
                                </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </section>
            </div>
            <Modal
                show={orderShow}
                onHide={orderHide}
                backdrop="static"
                className="detail_modal order_summary"
                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        <h4>Order Summary</h4>
                        <span className="cross_icon">
                            <img src={Icons.ModalCross} alt="" className="img-fluid" onClick={orderHide} />
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="account_option_wrapper">
                        <div className="main_accrodion">
                            <div id="accordion">
                                {
                                    vibes &&
                                    <div className="vibe_dropdown_wrapper">
                                        <div className="vibe_header">
                                            <a className="card-link" data-toggle="collapse" href="#collapseOne">
                                                <div className="vibe_plans_hedr d-flex align-items-center justify-content-between">
                                                    <div className="vibe_ttl">
                                                        <h6>Vibe Package</h6>
                                                    </div>
                                                    <div className="vibe_price">
                                                        <span>₹{pendrivePriceshow}</span>
                                                    </div>
                                                </div>
                                                <span className="down_arrow">
                                                    <img src={Icons.OrderDropdown} alt="Dropdown" className="img-fluid" />
                                                </span>
                                            </a>
                                        </div>
                                        <div id="collapseOne" className="collapse show" data-parent="#accordion">
                                            <div className="price_body">
                                                <ul type="none">
                                                    <li className="d-flex align-items-center justify-content-between">
                                                        <div className="vibe_amount">
                                                            <h6>Original Amount</h6>
                                                        </div>
                                                        <div className="vibe_price">
                                                            <span>₹{validity?.penDrive?.afterBuyPendrivePrice}</span>
                                                        </div>
                                                    </li>
                                                    <li className="d-flex align-items-center justify-content-between">
                                                        <div className="vibe_amount">
                                                            <h6>Discounted Amount</h6>
                                                        </div>
                                                        <div className="vibe_price">
                                                            <span className="green">-₹{validity?.penDrive?.afterBuyPendriveDiscount !== 0 ? validity?.penDrive?.afterBuyPendrivePrice - validity?.penDrive?.afterBuyPendriveDiscount : validity?.penDrive?.afterBuyPendriveDiscount}</span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {
                                    notes &&
                                    <div className="vibe_dropdown_wrapper">
                                        <div className="vibe_header">
                                            <a className="card-link" data-toggle="collapse" href="#collapseTwo">
                                                <div className="vibe_plans_hedr d-flex align-items-center justify-content-between">
                                                    <div className="vibe_ttl">
                                                        <h6>Notes Amount</h6>
                                                    </div>
                                                    <div className="vibe_price">
                                                        <span>₹{notePriceshow}</span>
                                                    </div>
                                                </div>
                                                <span className="down_arrow">
                                                    <img src={Icons.OrderDropdown} alt="Dropdown" className="img-fluid" />
                                                </span>
                                            </a>
                                        </div>
                                        <div id="collapseTwo" className="collapse" data-parent="#accordion">
                                            <div className="price_body">
                                                <ul type="none">
                                                    <li className="d-flex align-items-center justify-content-between">
                                                        <div className="vibe_amount">
                                                            <h6>Original Amount</h6>
                                                        </div>
                                                        <div className="vibe_price">
                                                            <span>₹{validity?.notes?.afterBuyNotesPrice}</span>
                                                        </div>
                                                    </li>
                                                    <li className="d-flex align-items-center justify-content-between">
                                                        <div className="vibe_amount">
                                                            <h6>Discounted Amount</h6>
                                                        </div>
                                                        <div className="vibe_price">
                                                            <span className="green">-₹{validity?.notes?.afterBuyNotesDiscount !== 0 ? validity?.notes?.afterBuyNotesPrice - validity?.notes?.afterBuyNotesDiscount : validity?.notes?.afterBuyNotesDiscount}</span>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="final_price">
                            <ul type="none">
                                <li className="d-flex align-items-center justify-content-between">
                                    <div className="vibe_amount">
                                        <h6>Coupon Amount</h6>
                                    </div>
                                    <div className="vibe_price">
                                        <span className="green">-₹{Price}</span>
                                    </div>
                                </li>
                                {/* <li className="d-flex align-items-center justify-content-between">
                                <div className="vibe_amount">
                                    <h6>Coin Discount</h6>
                                </div>
                                <div className="vibe_price">
                                    <span>₹ 0</span>
                                </div>
                            </li> */}
                                <li className="d-flex align-items-center justify-content-between">
                                    <div className="vibe_amount">
                                        <h6 className="green">Total Amount</h6>
                                    </div>
                                    <div className="vibe_price">
                                        <span className="green">₹ {TotalAmount}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}